// import { format } from 'date-fns';
import { ColumnFilter } from './ColumnFilter';

// Format date function
function dateFormat(value) {
	let objectDate = new Date(value);
	let day = ("0" + (objectDate.getDate() + 1)).slice(-2);
	let month = ("0" + (objectDate.getMonth() + 1)).slice(-2);
	let year = objectDate.getFullYear();
	
	return day + "/" + month + "/" + year;	 
}

export const COLUMNS = [
	{
		Header: 'techniciansalariesID',
		Footer: 'techniciansalariesID',
		accessor: 'techniciansalariesID',
		Filter: ColumnFilter,
	},
	{
		Header: 'اسم الموظف', // Technician Name
		Footer: 'Technician Name',
		accessor: 'technician.FirstName', // Accessing Technician's first name from relation
 		Filter: ColumnFilter,
	},
	{
		Header: 'تاريخ الراتب', // Salary Date
		Footer: 'Salary Date',
		accessor: 'SalaryDate',
		Cell: ({ value }) => dateFormat(value), // Apply date formatting
		Filter: ColumnFilter,
	},
	{
		Header: 'قيمة الخدمة', // Service Standard Price
		Footer: 'Service Price',
		accessor: 'ServiceStandardPrice',
		Filter: ColumnFilter,
	},
	{
		Header: 'تكلفة الموظف', // Salary Amount
		Footer: 'Total Salary',
		accessor: 'SalaryAmount',
		Filter: ColumnFilter,
	},
	{
		Header: 'حالةالدفع', // Invoice Number from RepairOrder
		Footer: 'رقم الفاتورة',
		accessor: 'PayStatus', // Accessing Invoice Number from the RepairOrder relation
		Filter: ColumnFilter,
	},
	{
		Header: 'رقم الفاتورة', // Invoice Number from RepairOrder
		Footer: 'رقم الفاتورة',
		accessor: 'repair_order.InvoiceNumber', // Accessing Invoice Number from the RepairOrder relation
		Filter: ColumnFilter,
	},
];

export const GROUPED_TECHNICIAN_SALARY_COLUMNS = [
	{
		Header: 'Salary Information',
		Footer: 'Salary Information',
		columns: [
			{
				Header: 'Salary ID',
				Footer: 'Salary ID',
				accessor: 'TechnicianSalaryID'
			},
			{
				Header: 'اسم الموظف', // Technician Name
				Footer: 'Technician Name',
				accessor: 'technician.FirstName',
				Cell: ({ row }) => `${row.original.technician.FirstName} ${row.original.technician.LastName}`,
			},
			{
				Header: 'تاريخ الراتب', // Salary Date
				Footer: 'Salary Date',
				accessor: 'SalaryDate',
				Cell: ({ value }) => dateFormat(value), // Format the date
			},
		],
	},
	{
		Header: 'Financial Details',
		Footer: 'Financial Details',
		columns: [
			{
				Header: 'قيمة الخدمة', // Service Standard Price
				Footer: 'Service Price',
				accessor: 'ServiceStandardPrice'
			},
			{
				Header: 'المبلغ الكلي', // Salary Amount
				Footer: 'Total Salary',
				accessor: 'SalaryAmount'
			},
			{
				Header: 'رقم الفاتورة', // Invoice Number
				Footer: 'رقم الفاتورة',
				accessor: 'repairOrder.InvoiceNumber'
			},
		]
	},
];
